import { GCP_ENTITY_TYPE_TO_TEXT } from '../constants/admin.schools.constants';

export const gcpSchoolToType = (school) => GCP_ENTITY_TYPE_TO_TEXT?.[school?.spoEntityMeta?.type] ?? 'Onbekend';
